import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";

export default function BusSummaryTable({ rows }) {
  return (
    <div
      className="border border-border rounded-[2px] overflow-x-auto bg-background"
      data-testid="bus-summary-table"
    >
      <Table>
        <TableHeader>
          <TableRow className="bg-secondary/60 hover:bg-secondary/60">
            <TableHead className="text-[10px] uppercase tracking-[0.18em] font-semibold w-20">
              Bus
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold text-[var(--doe-import)]">
              Avg import (MW)
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold">
              Min import
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold">
              Max import
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold text-[var(--doe-export)]">
              Avg export (MW)
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold">
              Min export
            </TableHead>
            <TableHead className="text-right text-[10px] uppercase tracking-[0.18em] font-semibold">
              Max export
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow
              key={r.bus}
              className="font-mono text-xs"
              data-testid={`bus-summary-row-${r.bus}`}
            >
              <TableCell className="font-semibold">#{r.bus}</TableCell>
              <TableCell className="text-right text-[var(--doe-import)] font-semibold">
                {r.avg_import_mw.toFixed(2)}
              </TableCell>
              <TableCell className="text-right">{r.min_import_mw.toFixed(2)}</TableCell>
              <TableCell className="text-right">{r.max_import_mw.toFixed(2)}</TableCell>
              <TableCell className="text-right text-[var(--doe-export)] font-semibold">
                {r.avg_export_mw.toFixed(2)}
              </TableCell>
              <TableCell className="text-right">{r.min_export_mw.toFixed(2)}</TableCell>
              <TableCell className="text-right">{r.max_export_mw.toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
